// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mail-fixed{position:fixed;width:100%}.mail-entry:last-child{border-bottom:0}\n", ""]);
// Exports
module.exports = exports;
